export default __webpack_public_path__ + "static/media/not_found_empty.a0301ceb.svg";